import { datadogLogs } from '@datadog/browser-logs';
import { ContextLog } from 'constants/contextLog';
import { LogType } from 'constants/logType';
import { getUserInfo } from './user';

class ApiError extends Error {
	constructor(message: string, protected status: string, name: string) {
		super(message);
		this.name = name;
	}
}

type loggerInfoProps = {
	data: any;
	context: ContextLog;
	location?: string | undefined;
	type?: LogType;
	payloadRequest?: any;
	uuid?: string | undefined;
};

const COMMOM_ERRORS = [400, 401, 403, 404, 500, 501, 502, 503, 504];

export const loggerInfo = ({
	data,
	uuid,
	context,
	location,
	payloadRequest,
	type = 'error',
}: loggerInfoProps) => {
	const user = getUserInfo();
	const payload = {
		uuid: uuid,
		context,
		browserDate: new Date().toISOString(),
		user: { ...user },
		error: data?.response ? data.response.data : data,
		name: location,
		message: data?.message,
		payloadRequest: payloadRequest,
		awsTraceId: data?.config?.headers?.['X-Amzn-Trace-Id'],
		awsRequestId: data?.config?.headers?.['X-Amzn-Requestid'],
	};

	if (data?.response?.status && COMMOM_ERRORS.includes(data.response.status)) {
		const errorCode = data.response.status;
		const error = new ApiError(payload.message, errorCode, data?.code);
		datadogLogs.logger.error(context, { ...payload }, error);
		return;
	}

	datadogLogs.logger[type](context, { ...payload });
};
